import React from 'react';
import PropTypes from 'prop-types';
import _find from 'lodash/find';
import { LocalizedMessage } from 'intl/LocalizedComponents';
// HOCs
import { connect } from 'react-redux';
// Core components
import Link from 'components/core/Link';
import Tooltip from 'components/core/Tooltip';
// Custom
import { companyDataShape } from 'constants/PropTypesShapes';
import { showPath } from 'companies/navigation';

const CompanyTooltipContent = ({ company }) => (
  <div>
    <div className="row m-0">
      <div className="w-100 text-center">
        {company.name}
      </div>
    </div>
    <div className="pt-2">
      <div className="box-divider-light m-0" />
      <div className="row m-0 pt-2">
        <div className="w-100 text-center">
          <LocalizedMessage id="tooltip.clickToAccess" values={{ resource: 'company' }} />
        </div>
      </div>
    </div>
  </div>
);

CompanyTooltipContent.propTypes = {
  company: companyDataShape.isRequired,
};

const CompanyIdLink = ({ company }) => {
  if (company) {
    return (
      <div className="d-flex align-items-center">
        <Tooltip
          content={<CompanyTooltipContent company={company} />}
          inheritStyle={false}
          className="text-truncate"
        >
          <Link path={showPath(company.id)}>
            {company.name}
          </Link>
        </Tooltip>
      </div>
    );
  }
  return null;
};

CompanyIdLink.propTypes = {
  // companyId prop is only used in mapStateToProps
  companyId: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
  // From `connect` HOC
  company: companyDataShape,
};

CompanyIdLink.defaultProps = {
  companyId: null,
  company: null,
};

const mapStateToProps = (state, ownProps) => ({
  company: _find(state.company.list.flattenElements, ['id', ownProps.companyId]),
});

module.exports = connect(mapStateToProps)(CompanyIdLink);



// WEBPACK FOOTER //
// ./routes/app/routes/companies/assets/main/CompanyIdLink.js